import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import CompanySelector from './companySelector';
import Company from './company';
import locales from './locales';

class Companies extends Component {
  static propTypes = {
    authInfo: PropTypes.object.isRequired,
    onChangeCompany: PropTypes.func.isRequired,
    myAccountUrl: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.authInfo = props.authInfo;
  }

  getCompanySingle() {
    return <Company authInfo={this.authInfo} />;
  }

  getCompanyMulti(companies, groupCompanies) {
    const { onChangeCompany, lang, myAccountUrl } = this.props;
    const t = locales(lang);
    return (
      <Fragment>
        {t('globalHeader.companies.title')}
        <CompanySelector
          companies={companies}
          groupCompanies={groupCompanies}
          authInfo={this.authInfo}
          onChangeCompany={onChangeCompany}
          lang={lang}
          myAccountUrl={myAccountUrl}
        />
      </Fragment>
    );
  }

  getCompaniesSorted() {
    const { authInfo } = this.props;
    let companies = (authInfo.getCompanies && authInfo.getCompanies()) || [];

    if (companies.length === 0) {
      companies = (authInfo.getGroupCompanies && authInfo.getGroupCompanies()) || [];
    }
    return companies.sort((a, b) => a.name.localeCompare(b.name));
  }

  clearCompanies(companies) {
    const { authInfo } = this.props;
    const groupCompanies = (authInfo.getGroupCompanies && authInfo.getGroupCompanies()) || [];

    return groupCompanies
      .map((groupCompany, i) => {
        return !companies.find(company => {
          return groupCompany.id == company.id;
        })
          ? groupCompany
          : null;
      })
      .filter(n => n)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  render() {
    const companies = this.getCompaniesSorted();
    const groupCompanies = this.clearCompanies(companies);

    return (
      <div className={'companies__dropdown'}>
        {companies.length > 1 || groupCompanies.length > 0
          ? this.getCompanyMulti(companies, groupCompanies)
          : this.getCompanySingle()}
      </div>
    );
  }
}

Companies.propTypes = {
  onChangeCompany: PropTypes.func,
  authInfo: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  myAccountUrl: PropTypes.string.isRequired,
};

export default Companies;
